module.exports = __webpack_public_path__ + "static/img/hdw2.d2de3250.png";